var _path, _path2, _circle, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOnPriceVermelho(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 28L11 31H14L15 30H18.5L20 31H23L20.5 28H18.5V26.5H25.5V13H8V26.5H15V28H13.5Z",
    stroke: "#A80A01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24H29V32L31.5 31H33.5L36 32V24Z",
    stroke: "#A80A01"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 26.5,
    r: 0.5,
    fill: "#A80A01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 11V22.5H36V11H29Z",
    stroke: "#A80A01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 15V19",
    stroke: "#A80A01",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnPriceVermelho);
export default __webpack_public_path__ + "static/media/Logo OnPrice Vermelho.0e41c62a7acff589822dc9c12a627315.svg";
export { ForwardRef as ReactComponent };